import { render, staticRenderFns } from "./VbgBuildInfoCardBody.vue?vue&type=template&id=af59a1ac&scoped=true"
import script from "./VbgBuildInfoCardBody.vue?vue&type=script&lang=js"
export * from "./VbgBuildInfoCardBody.vue?vue&type=script&lang=js"
import style0 from "./VbgBuildInfoCardBody.vue?vue&type=style&index=0&id=af59a1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af59a1ac",
  null
  
)

export default component.exports